
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 12 12","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.619 5.619h-.962a4.673 4.673 0 00-4.276-4.364V.38a.381.381 0 00-.762 0v.874a4.673 4.673 0 00-4.276 4.364H.38a.381.381 0 000 .762h.976a4.674 4.674 0 004.262 4.174v1.064a.38.38 0 10.762 0v-1.064a4.674 4.674 0 004.261-4.174h.977a.381.381 0 100-.762zm-1.729 0h-.906v-.457a.381.381 0 00-.762 0v.457h-.38v-.457a.381.381 0 00-.763 0v.457h-.698v-.762h.393a.381.381 0 000-.762h-.393v-.38h.393a.381.381 0 000-.763h-.393V2.02a3.908 3.908 0 013.51 3.6zm-4.271-3.6v.933h-.393a.381.381 0 000 .762h.393v.381h-.393a.381.381 0 000 .762h.393v.762H4.92v-.457a.381.381 0 00-.762 0v.457h-.38v-.457a.381.381 0 00-.762 0v.457H2.11a3.908 3.908 0 013.509-3.6zM2.127 6.381h.889v.33a.381.381 0 00.762 0v-.33h.38v.33a.381.381 0 00.762 0v-.33h.699v.635h-.393a.38.38 0 100 .762h.393v.38h-.393a.38.38 0 100 .763h.393v.87a3.91 3.91 0 01-3.492-3.41zm4.254 3.41v-.87h.393a.381.381 0 000-.762h-.393v-.381h.393a.381.381 0 000-.762h-.393v-.635h.698v.33a.38.38 0 10.762 0v-.33h.381v.33a.38.38 0 10.762 0v-.33h.888a3.909 3.909 0 01-3.491 3.41z"}})])
          )
        }
      }
    